import { render, staticRenderFns } from "./ListMessages.vue?vue&type=template&id=757a9ade"
import script from "./ListMessages.vue?vue&type=script&lang=js"
export * from "./ListMessages.vue?vue&type=script&lang=js"
import style0 from "./ListMessages.vue?vue&type=style&index=0&id=757a9ade&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('757a9ade')) {
      api.createRecord('757a9ade', component.options)
    } else {
      api.reload('757a9ade', component.options)
    }
    module.hot.accept("./ListMessages.vue?vue&type=template&id=757a9ade", function () {
      api.rerender('757a9ade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Tickets/components/ListMessages.vue"
export default component.exports